import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';
import { ADMIN_EMAIL } from '../services/auth';
import fateRoomLogo from '../assets/images/fate-room-logo.svg';
import { useI18n } from '../i18n/I18nContext';
import LanguageSelector from './LanguageSelector';
import '../style/Header.css';

const Header = () => {
  const { user, isLoggedIn, userType } = useContext(AuthContext);
  const { t } = useI18n();
  const signedIn = Boolean(user || isLoggedIn);
  const isAdmin = userType === 'admin'
    || String(user?.email || '').trim().toLowerCase() === ADMIN_EMAIL;
  const dashboardPath = userType === 'teller' ? '/teller-dashboard' : '/user-dashboard';
  return (
    <header className="site-header">
      <Link to="/" className="brand-logo" aria-label={t('a11y.home')}>
        <img src={fateRoomLogo} alt="Fate Room" className="fate-room-logo" />
      </Link>

      <nav className="main-nav" aria-label={t('a11y.mainNavigation')}>
        <Link to="/find-teller">{t('nav.browse')}</Link>
        <Link to="/our-services">{t('nav.features')}</Link>
        <Link to="/how-it-works">{t('nav.how')}</Link>
        <Link to="/content-library">{t('nav.library')}</Link>
      </nav>

      <div className="header-actions">
        <LanguageSelector compact />
        {signedIn ? (
          isAdmin ? (
            <>
              <Link to="/admin-login" className="header-cta">{t('nav.admin')}</Link>
              <Link to="/logout" className="header-logout">{t('nav.logout')}</Link>
            </>
          ) : (
            <>
              <Link to="/notifications" className="header-notifications" aria-label={t('nav.notifications')}>
                  <span aria-hidden="true">✦</span>
                  <span>{t('nav.notifications')}</span>
              </Link>
              <Link to={dashboardPath} className="header-cta">{t('nav.dashboard')}</Link>
              <Link to="/logout" className="header-logout">{t('nav.logout')}</Link>
            </>
          )
        ) : (
          <>
            <Link to="/login" className="header-link">{t('nav.login')}</Link>
            <Link to="/register" className="header-cta">{t('nav.create')}</Link>
          </>
        )}
      </div>
    </header>
  );
};

export default Header;
